<template>
  <svg
    version="1.1"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :heigth="size"
  >
    <path d="M0,0h24v24h-24Z" fill="none" />
    <path
      fill="currentColor"
      d="M20.821,3.179c-0.76,-0.761 -1.772,-1.179 -2.847,-1.179c-1.074,0 -2.086,0.418 -2.846,1.179l-11.409,11.408c4.44089e-16,0 -0.001,0.003 -0.003,0.004c-0.081,0.082 -0.219,0.298 -0.261,0.461l-1.425,5.704c-0.086,0.34 0.015,0.702 0.263,0.949l0.001,0.001l0.001,0.001c0.248,0.248 0.608,0.349 0.949,0.264l5.704,-1.427c0.163,-0.042 0.38,-0.18 0.461,-0.261c0.001,-0.001 0.004,-0.003 0.004,-0.003l11.409,-11.407c0.76,-0.761 1.179,-1.771 1.178,-2.847c0,-1.075 -0.418,-2.086 -1.178,-2.847h-0.001Zm-6.41,3.549l2.863,2.863l-8.568,8.568l-2.863,-2.863l8.568,-8.568Zm-10.036,12.898l0.595,-2.374l1.78,1.781l-2.375,0.593Zm15.034,-15.032c0.764,0.765 0.764,2.099 0,2.864l-0.719,0.72l-2.866,-2.865l0.721,-0.719c0.765,-0.764 2.099,-0.765 2.864,0Z"
    />
  </svg>
</template>

<script>
'use strict'

import mixinIcon from '../mixinIcon'

export default {
  name: 'pencil',
  mixins: [mixinIcon]
}
</script>
